import {ContentType} from 'sdk/src/defines';

type Payload = {
  contentType: ContentType,
  filters?: Record<string, any>,
};

const initialState = {
  entities: {},
};

const filtersReducer = (state = initialState, action: {type: string, payload: Payload}) => {
  switch (action.type) {
    case 'HANDLE_CONTENT_FILTER_SELECTED': {
      const {contentType, filters} = action.payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [contentType]: filters
        }
      }
    }
    case 'HANDLE_CONTENT_FILTERS_CLEARED': {
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.payload.contentType]: {}
        }
      }
    }
    default:
      return state;
  }
};

export default filtersReducer;